import { AlertModal, Button } from '@adamdotai/design-system'
import { useTranslations } from 'next-intl'

type ReplaceNotesProps = {
    isOpen: boolean
    onClose: () => void
    onReplace: () => void
}

export const ReplaceNotes = ({
    isOpen,
    onClose,
    onReplace,
}: ReplaceNotesProps) => {
    const t = useTranslations()
    return (
        <AlertModal
            isOpen={isOpen}
            onClose={onClose}
            leastDestructiveRef={null}
        >
            <AlertModal.Content>
                <AlertModal.Close />
                <AlertModal.Header>
                    {t('meetingroom.replace-notes')}
                </AlertModal.Header>
                <AlertModal.Body>
                    {t('meetingroom.replace-meeting-summary-text')}
                </AlertModal.Body>
                <AlertModal.Footer>
                    <Button size="md" variant="outline" onClick={onClose}>
                        {t('common.cancel')}
                    </Button>
                    <Button size="md" colorScheme="primary" onClick={onReplace}>
                        {t('common.replace')}
                    </Button>
                </AlertModal.Footer>
            </AlertModal.Content>
        </AlertModal>
    )
}
